import { jwtDecode } from "jwt-decode";

export type RoleString =
  | "SuperAdmin"
  | "BizboxAdmin"
  | "GroupAdmin"
  | "CoGroupAdmin"
  | "FacilityAdmin"
  | "CoFacilityAdmin"
  | "User"
  | "BizboxUser";

interface DecodedToken {
  role?: string | string[]; // Allow both string and array of strings
}

export const GetRole = (token?: string): RoleString[] => {
  if (!token) return [];

  try {
    const decodedToken: DecodedToken = jwtDecode(token);

    // Ensure role is always an array
    const roles: string[] = decodedToken.role
      ? Array.isArray(decodedToken.role)
        ? decodedToken.role
        : [decodedToken.role]
      : [];

    // Filter only valid RoleString values
    const validRoles: RoleString[] = roles.filter((r): r is RoleString =>
      (
        [
          "SuperAdmin",
          "BizboxAdmin",
          "GroupAdmin",
          "CoGroupAdmin",
          "FacilityAdmin",
          "CoFacilityAdmin",
          "User",
          "BizboxUser",
        ] as const
      ).includes(r as RoleString)
    );

    return validRoles;
  } catch (error) {
    console.error("Invalid token:", error);
    return [];
  }
};

export const getHighestRole = (
  roles?: RoleString[] | undefined
): RoleString => {
  if (!roles || roles.length === 0) return "User";

  const roleHierarchy: RoleString[] = [
    "SuperAdmin",
    "BizboxAdmin",
    "GroupAdmin",
    "CoGroupAdmin",
    "FacilityAdmin",
    "CoFacilityAdmin",
    "User",
    "BizboxUser",
  ];

  // Find the highest role based on the hierarchy
  const highestRole = roles.reduce((highest, current) => {
    const currentIndex = roleHierarchy.indexOf(current);
    const highestIndex = roleHierarchy.indexOf(highest);
    return currentIndex < highestIndex ? current : highest;
  }, roles[0]);

  return highestRole;
};
